/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPASSETTYPE } from './IAPASSETTYPE';
import {
    IAPASSETTYPEFromJSON,
    IAPASSETTYPEFromJSONTyped,
    IAPASSETTYPEToJSON,
} from './IAPASSETTYPE';
import type { IAPSWITCHOUTTYPE } from './IAPSWITCHOUTTYPE';
import {
    IAPSWITCHOUTTYPEFromJSON,
    IAPSWITCHOUTTYPEFromJSONTyped,
    IAPSWITCHOUTTYPEToJSON,
} from './IAPSWITCHOUTTYPE';

/**
 * 
 * @export
 * @interface InvestmentDetailsPhaseInFromFundViewModel
 */
export interface InvestmentDetailsPhaseInFromFundViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsPhaseInFromFundViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsPhaseInFromFundViewModel
     */
    assetCode?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsPhaseInFromFundViewModel
     */
    switchValue?: number;
    /**
     * 
     * @type {IAPASSETTYPE}
     * @memberof InvestmentDetailsPhaseInFromFundViewModel
     */
    assetTypeId?: IAPASSETTYPE;
    /**
     * 
     * @type {IAPSWITCHOUTTYPE}
     * @memberof InvestmentDetailsPhaseInFromFundViewModel
     */
    switchOutTypeId?: IAPSWITCHOUTTYPE;
}

/**
 * Check if a given object implements the InvestmentDetailsPhaseInFromFundViewModel interface.
 */
export function instanceOfInvestmentDetailsPhaseInFromFundViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvestmentDetailsPhaseInFromFundViewModelFromJSON(json: any): InvestmentDetailsPhaseInFromFundViewModel {
    return InvestmentDetailsPhaseInFromFundViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsPhaseInFromFundViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsPhaseInFromFundViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'assetCode': !exists(json, 'AssetCode') ? undefined : json['AssetCode'],
        'switchValue': !exists(json, 'SwitchValue') ? undefined : json['SwitchValue'],
        'assetTypeId': !exists(json, 'AssetTypeId') ? undefined : IAPASSETTYPEFromJSON(json['AssetTypeId']),
        'switchOutTypeId': !exists(json, 'SwitchOutTypeId') ? undefined : IAPSWITCHOUTTYPEFromJSON(json['SwitchOutTypeId']),
    };
}

export function InvestmentDetailsPhaseInFromFundViewModelToJSON(value?: InvestmentDetailsPhaseInFromFundViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'AssetCode': value.assetCode,
        'SwitchValue': value.switchValue,
        'AssetTypeId': IAPASSETTYPEToJSON(value.assetTypeId),
        'SwitchOutTypeId': IAPSWITCHOUTTYPEToJSON(value.switchOutTypeId),
    };
}

